<template>
  <div class="flex flex-col w-full h-full">
    <div class="flex flex-col h-full bg-white">
      <div class="gwd-table h-full">
        <div class="gwd-table-header tasks-costs-table gap-x-2">
          <span></span>
          <span class="mobile:col-span-2">Nimetus</span>
          <span>Kogus</span>
          <span class="mobile:col-span-2">Ühikukulu</span>
          <span class="mobile:col-span-2">Kulu*kogus</span>
          <span class="mobile:col-span-2">Koefitsent</span>
          <span>Kogukulu</span>
          <span class="mobile:col-span-4">Info</span>
          <span class="mobile:col-span-2">Staatus</span>
          <span class="mobile:col-span-2"></span>
        </div>
        <div v-show="taskCosts.length > 0" class="gwd-table-row-wrapper mt-1">
          <task-cost
            class="mb-1"
            v-for="cost in taskCosts"
            :key="`${cost.type}${cost.id}`"
            :cost="cost"
            :block-delete="cost.invoice"
            @editCost="editCost"
            @deleteCost="setCostToDelete"
            @confirm="confirmCost"
          />
        </div>
        <div
          v-if="taskCosts.length === 0"
          class="gwd-table-row-wrapper inline-block p-1"
        >
          <span class="p-2">Kulud puuduvad</span>
        </div>
        <div
          class="gwd-table-bottom-bar gap-x-3 mobile:flex-wrap mobile:grid mobile:grid-cols-2 mobile:gap-y-1"
        >
          <button
            v-if="taskData.related_object"
            class="btn-primary"
            @click="routeToOutgoingInvoiceCreation"
          >
            <span class="label">Arve koostamisse</span>
          </button>
          <button
            v-if="taskData.related_object"
            class="btn-primary"
            @click="routeToOutgoingInvoiceGeneratorView"
          >
            <span class="label">Arve kulude põhjal</span>
          </button>
          <button
            v-if="
              taskData.related_object &&
              revenueTemplates.length > 0 &&
              taskCosts.filter((x) => x.status < 2).length > 0
            "
            class="btn-primary"
            @click="routeToNewInvoiceRevenuesFromTemplates"
          >
            <span class="label">Tulu mallide põhjal</span>
          </button>
          <div class="flex items-center gap-x-2 mobile:col-span-2">
            <gwd-formlabel title="Kuva kustutatuid" />
            <gwd-checkbox v-model="showDeleted" size="6" />
          </div>
          <div
            v-if="uniqueInvoices.length > 0"
            class="flex items-center gap-x-1 ml-auto mobile:ml-9 mobile:col-span-2"
          >
            <span
              class="p-1 cursor-pointer inline-block rounded font-medium"
              :class="
                invoice.manually_checked ? 'bg-green' : 'bg-pending text-white'
              "
              v-for="invoice in uniqueInvoices"
              :key="invoice.id"
              @click="routeToOutgoingInvoice(invoice)"
            >
              Arve
              {{
                invoice.manually_checked
                  ? `nr: ${invoice.invoice_nr}`
                  : `id: ${invoice.id}`
              }}
            </span>
          </div>
          <div
            class="flex items-center gap-x-3 mobile:col-span-2 mobile:grid mobile:grid-cols-2 mobile:gap-y-1"
            :class="{ 'ml-auto mobile:ml-0': uniqueInvoices.length === 0 }"
          >
            <h4>Kogukulu</h4>
            <span>
              {{ round2(profits.total_cost) }}
              {{ $store.state.userData.user.currency }}
            </span>
            <h4>Kogutulu</h4>
            <span>
              {{ round2(profits.total_revenue) }}
              {{ $store.state.userData.user.currency }}
            </span>
            <h4>Kasum (Marginaal %)</h4>
            <span v-html="calculatedMarginals" />
          </div>
        </div>
      </div>
    </div>

    <delete-confirm-modal
      v-if="costToDelete"
      text="Olete kindel et soovite kulu kustutada?"
      @confirmDelete="deleteCost"
      @closeModal="costToDelete = null"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TaskCost from "@/components/project/costs/table/TaskCost.vue";
import DeleteConfirmModal from "@/components/reusable/DeleteConfirmModal.vue";
import { round2 } from "@/assets/utils/commonMath";
import { Revenue } from "@/assets/types/Revenue";
import set from "lodash/set";

export default {
  name: "TaskTotalCosts",
  components: { DeleteConfirmModal, TaskCost },
  props: {
    taskId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      taskCosts: [],
      costToDelete: null,
      profits: {
        total_cost: null,
        total_revenue: null,
      },
      uniqueInvoices: [],
      showDeleted: false,
      revenueTemplates: [],
    };
  },
  async mounted() {
    if (!this.taxTypes)
      await this.$store.dispatch("companyVariables/retrieveTaxTypes");
    if (!this.serviceObjects)
      await this.$store.dispatch("companyVariables/retrieveServiceObjects");
    if (!this.equipmentList)
      await this.$store.dispatch("companyVariables/retrieveEquipmentList");
    this.listTaskTotalCosts();
    this.retrieveTaskProfits();
    this.listTaskRevenueTemplates();
  },
  methods: {
    round2,
    async routeToOutgoingInvoiceCreation() {
      await this.$store.dispatch("invoice/setData", {
        projectId: this.taskData.related_object.object_uuid,
        client: this.taskData.related_object.client_id,
      });
      sessionStorage.removeItem("taskId");
      await this.$router.push("/invoices/outgoing/add");
      await this.$store.dispatch("modals/taskModal/close");
    },
    async routeToOutgoingInvoiceGeneratorView() {
      sessionStorage.removeItem("taskId");
      await this.$router.push(
        `/invoices/generator/${this.taskData.related_object.object_uuid}?view=2`
      );
      await this.$store.dispatch("modals/taskModal/close");
    },
    async routeToNewInvoiceRevenuesFromTemplates() {
      let templateTypeToCostMap = {
        1: this.taskCosts.filter(
          (x) => x.type === "workerCost" || x.type === "equipmentCost"
        ),
        2: this.taskCosts.filter((x) => x.type === "workerCost"),
        3: this.taskCosts.filter((x) => x.type === "resourceCost"),
        4: this.taskCosts.filter((x) => x.type === "equipmentCost"),
        5: this.taskCosts.filter((x) => x.type === "supplierCost"),
        6: this.taskCosts.filter((x) => x.type === "extraCost"),
        7: this.taskCosts,
      };
      let addedCosts = [];
      let addedRevenues = [];
      for (let template of this.revenueTemplates) {
        let costs = templateTypeToCostMap[template.type];
        costs.forEach((x) => addedCosts.push(`${x.type}${x.id}`));
        addedRevenues.push(
          new Revenue(
            null,
            template.serviceCode ?? null,
            1,
            template.unit,
            template.vatType ?? null,
            template.price,
            costs.map((x) => `${x.type}${x.id}`),
            template.description
          )
        );
      }
      for (let cost of this.taskCosts.filter(
        (x) => !addedCosts.includes(`${x.type}${x.id}`)
      )) {
        addedCosts.push(`${cost.type}${cost.id}`);
        addedRevenues.push(
          new Revenue(
            null,
            null,
            cost.amount,
            cost.unit,
            null,
            cost.price,
            [`${cost.type}${cost.id}`],
            cost.description
          )
        );
      }

      await this.$store.dispatch("invoice/setData", {
        revenues: addedRevenues,
        addedCosts: addedCosts,
        projectId: this.taskData.related_object.object_uuid,
        client: this.taskData.related_object.client_id,
        payer: this.taskData.payer ? this.taskData.payer.id : null,
      });
      await this.$router.push(`/invoices/outgoing/add/`);
      await this.$store.dispatch("modals/taskModal/close");
    },
    retrieveTaskProfits() {
      this.apiRequest(
        `tasks/${this.companyId}/${this.taskId}/profits/`,
        "get",
        true
      ).then((res) => {
        this.profits = res.data;
      });
    },
    listTaskRevenueTemplates() {
      this.apiRequest(
        `template/${this.companyId}/costs/templates/?object_id=${this.taskId}&type=task`,
        "get",
        true
      ).then((res) => {
        this.revenueTemplates = res.data;
        for (let template of this.revenueTemplates) {
          set(
            template,
            "vatType",
            this.taxTypes.find((x) => x.id === template.vat)
          );
          set(
            template,
            "serviceCode",
            this.serviceObjects.find((x) => x.id === template.service_code)
          );
        }
      });
    },
    listTaskTotalCosts() {
      this.apiRequest(
        `costs/${this.companyId}/task/${this.taskId}/list/total/?deleted=${this.showDeleted}`,
        "get",
        true
      ).then((res) => {
        this.taskCosts = res.data;
        this.uniqueInvoices = this.taskCosts
          .map((x) => x.outgoing_invoices)
          .flat()
          .reduce(
            (unique, item) =>
              unique.map((x) => x.id).includes(item.id)
                ? unique
                : [...unique, item],
            []
          );
      });
    },
    confirmCost(cost) {
      let url;
      if (cost.type === "workerCost") {
        url = `costs/${this.companyId}/worker/${cost.object_id}/${cost.id}/confirm/`;
      } else if (cost.type === "extraCost") {
        url = `costs/${this.companyId}/worker/${cost.object_id}/extra/${cost.id}/confirm/`;
      } else if (cost.type === "resourceCost") {
        url = `costs/${this.companyId}/resource/${cost.object_id}/${cost.id}/confirm/`;
      } else if (cost.type === "supplierCost") {
        url = `costs/${this.companyId}/supplier/${cost.object_id}/${cost.id}/confirm/`;
      } else if (cost.type === "equipmentCost") {
        url = `costs/${this.companyId}/equipment/${cost.object_id}/${cost.id}/confirm/`;
      }
      this.apiRequest(url, "post", true).then(() => this.listTaskTotalCosts());
    },
    editCost(e) {
      this.apiRequest(
        `costs/${this.companyId}/costs/${e.type}/${e.id}/edit/`,
        "patch",
        true,
        e
      )
        .then((res) => {
          if (res.status === 200) {
            this.listTaskTotalCosts();
          }
        })
        .catch((err) =>
          this.$store.dispatch("messageHandler/throwMessage", {
            type: "error",
            error: err,
            text: "Midagi läks valesti",
            ttl: 5,
          })
        );
    },
    setCostToDelete(e) {
      this.costToDelete = e;
    },
    deleteCost() {
      if (!this.costToDelete) return;
      this.apiRequest(
        `costs/${this.companyId}/costs/${this.costToDelete.type}/${this.costToDelete.id}/delete/`,
        "delete",
        true
      )
        .then((res) => {
          if (res.status === 200) {
            this.listTaskTotalCosts();
          }
        })
        .catch((err) =>
          this.$store.dispatch("messageHandler/throwMessage", {
            type: "error",
            error: err,
            text: "Kulu kustutamine ebaõnnestus!",
            ttl: 5,
          })
        );
    },
    routeToOutgoingInvoice(invoice) {
      const route = this.$router.resolve({
        path: invoice.manually_checked
          ? `/invoices/outgoing/confirmed/${invoice.id}`
          : `/invoices/outgoing/${invoice.id}`,
        query: {
          view: 6,
        },
      });
      window.open(route.href, "_blank");
    },
  },
  watch: {
    showDeleted() {
      this.listTaskTotalCosts();
    },
  },
  computed: {
    ...mapGetters({
      companyId: "companyData/activeCompanyUuid",
      taskData: "modals/taskModal/taskData",
      serviceObjects: "companyVariables/serviceObjects",
      taxTypes: "companyVariables/taxTypes",
      equipmentList: "companyVariables/equipmentList",
    }),
    calculatedMarginals() {
      const revenue = parseFloat(this.profits.total_revenue ?? "0");
      const cost = parseFloat(this.profits.total_cost ?? "1");

      const profit = revenue - cost;
      let marginalPercent = -100;
      if (revenue !== 0) {
        marginalPercent = (profit / revenue) * 100;
      }
      let textColor;
      if (isNaN(marginalPercent)) {
        textColor = "black";
      } else if (marginalPercent < 0) {
        textColor = "danger"; // red for negative
      } else if (marginalPercent < 15) {
        textColor = "attention"; // yellow for 0-14.99%
      } else if (marginalPercent < 30) {
        textColor = "black"; // black for 15-29.99%
      } else {
        textColor = "green"; // green for 30% and above
      }

      return `<span class="text-sm text-${textColor}">${round2(
        profit
      )} € (${round2(marginalPercent)}%)</span>`;
    },
  },
};
</script>

<style lang="scss">
.tasks-costs-table {
  //                     type       amount      total       total       status
  //                          name        cost        cost_co     info         edit
  grid-template-columns: 3rem 0.5fr 0.1fr 0.1fr 0.1fr 0.1fr 0.1fr 0.4fr 0.15fr 0.2fr;
  @media screen and (max-width: 601px) {
    @apply grid m-1 border-b border-b-offwhite-dark gap-y-1 w-full;
    grid-template-columns: 3rem 0.33fr 0.33fr 0.34fr;
  }
}
</style>
